// extracted by mini-css-extract-plugin
module.exports = {"sidebar-item":"style_sidebar-item__4WOSD","sidebar-item__link":"style_sidebar-item__link__NfpRR"};